export const environment = {
  production: false,
  homeVideoURL: 'https://radian01.blob.core.windows.net/onemorningdevcomm/fixedcontent/one_morning_-_moments_of_realization.mp4?sp=r&st=2025-03-18T15:46:07Z&se=2100-03-18T23:46:07Z&spr=https&sv=2022-11-02&sr=c&sig=JlErJwVi1k7X0ZtONBpQoDn0Nk%2FDl%2FJ%2FLJncB2BLBrE%3D',
  learnMoreVideoURL: 'https://radian01.blob.core.windows.net/onemorningdevcomm/fixedcontent/one_morning_-_what\'s_an_eap.mp4?sp=r&st=2025-03-18T15:46:07Z&se=2100-03-18T23:46:07Z&spr=https&sv=2022-11-02&sr=c&sig=JlErJwVi1k7X0ZtONBpQoDn0Nk%2FDl%2FJ%2FLJncB2BLBrE%3D'
};

